/** La famiglia di un tipo di movimento: segue la direzione del denaro (vedi `TxTypeBadge`). */
export type Family = 'buy' | 'sell' | 'income' | 'cash-in' | 'cash-out' | 'cost' | 'other';

const FAMILY_OF: Record<string, Family> = {
  buy: 'buy',
  savings_plan: 'buy',
  sell: 'sell',
  dividend: 'income',
  interest: 'income',
  staking_reward: 'income',
  deposit: 'cash-in',
  transfer_in: 'cash-in',
  withdrawal: 'cash-out',
  transfer_out: 'cash-out',
  fee: 'cost',
  tax: 'cost',
};

export function familyOf(txType: string): Family {
  return FAMILY_OF[txType] ?? 'other';
}
